import { tv } from '@workspace/lib';

export const featuredCardsVariants = tv({
  slots: {
    container: 'gap-lg px-md py-2xl md:gap-xl md:px-full-banner md:py-3xl',
    header: 'gap-xs md:gap-sm',
    heading: 'font-normal text-black',
    subheading: 'font-light text-black',
    list: 'w-[calc(100vw-24px)] gap-x-sm gap-y-lg pr-md md:pr-0 md:w-full',
    card: 'md:gap-y-0',
    imageWrapper: 'rounded-xl bg-neutral-100 aspect-2/3',
    image: '',
    content: 'gap-3 pt-xs',
    text: 'font-normal text-neutral-500',
    link: 'after:rounded-xl focus-visible:after:outline-primary-300',
    arrow: 'text-primary-300',
  },
  variants: {
    layout: {
      pair: {},
      // Shared image/caption rows align image bottoms even when titles wrap.
      mosaic: {
        list: 'md:grid-rows-[1fr_auto_1fr_auto]',
        imageWrapper: 'md:aspect-auto',
      },
    },
    size: {
      small: {},
      medium: { card: 'md:col-span-2' },
      large: {
        card: 'md:col-span-2 md:row-span-4',
        imageWrapper: 'md:row-span-3 md:aspect-2/3',
      },
    },
    hasLink: {
      true: {
        image: 'group-hover:scale-[1.03]',
      },
    },
  },
});
